module.exports = "//static.hsappstatic.net/LoginUI/static-1.15074/img/donut_desktop.svg"